import React from "react"
import Link from "./link"
import Img from "gatsby-image"
import { Box, Text } from "theme-ui"
import { LangContext } from "../context/langContext"
import ArrowLink from "./arrowLink"
import { getProductPath } from "../utils/pathUtils"

const ProductThumb = ({ product }) => (
  <Link
    to={getProductPath(product)}
    key={product.id}
    sx={{
      textDecoration: "none",
      color: "dark",
      "&:hover": {
        h3: {
          color: "primary",
        },
        ".gatsby-image-wrapper": {
          opacity: 0.8,
        },
      },
    }}
  >
    {product.image && (
      <Box mb={3}>
        <Img fluid={product.image.fluid} />
      </Box>
    )}
    <Text variant="lead" as="h3" mb={2}>
      {product.name}
    </Text>
    {product.summary && (
      <Text variant="caption" mb={2}>
        {product.summary}
      </Text>
    )}
    {!product.summary && product.description && (
      <Text
        variant="caption"
        dangerouslySetInnerHTML={{ __html: product.description }}
      />
    )}
    <LangContext.Consumer>
      {t => <ArrowLink anchor={t.discoverMore} />}
    </LangContext.Consumer>
  </Link>
)

export default ProductThumb
